// diviATE! Flavour Product Page — gallery dot sync + sticky mobile add-to-cart bar.
// The sticky button forwards its click to the real add-to-cart button inside
// the section's product form, so there is a single source of truth for the
// actual add-to-cart request (no duplicated cart logic).
document.querySelectorAll('.diviate-flavour-pdp').forEach((root) => {
  const track = root.querySelector('[ref="pfdGalleryTrack"]');
  const dotsWrap = root.querySelector('[ref="pfdGalleryDots"]');
  if (track && dotsWrap) {
    const dots = Array.from(dotsWrap.querySelectorAll('.pfd-gallery-dot'));
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });
    track.addEventListener(
      'scroll',
      () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      },
      { passive: true }
    );
  }

  const inlineCta = root.querySelector('[ref="pfdInlineCta"]');
  const sticky = root.querySelector('[ref="pfdSticky"]');
  const stickyButton = root.querySelector('[ref="pfdStickyButton"]');
  const realAddToCartButton = root.querySelector('.pfd-add-to-cart');

  if (inlineCta && sticky) {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          sticky.dataset.visible = 'false';
        } else {
          // Only show once the inline CTA has scrolled above the viewport
          // (not before it's been reached on first paint).
          sticky.dataset.visible = entry.boundingClientRect.bottom < 0 ? 'true' : 'false';
        }
      },
      { threshold: 0 }
    );
    observer.observe(inlineCta);
  }

  if (stickyButton && realAddToCartButton) {
    stickyButton.addEventListener('click', () => realAddToCartButton.click());
  }
});
